import {Box, Grid, IconButton, Link, Stack, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import packageJson from "../../../../package.json";
import {useQueryMedia} from "../../../hooks/useQueryMedia";
import Colors from "../../../utils/Colors";
import Images from "../../../utils/Images";
import Routers from "../../../utils/Routes";
import ButtonCustom from "../../shared/button-custom/ButtonCustom";
import ArrowIcon from "../../shared/icons/ArrowIcon";
import ProffessorIcon from "../../shared/icons/ProffessorIcon";
import StudentIcon from "../../shared/icons/StudentIcon";
import LogoBigPurple from "../../shared/icons/logo/LogoBigPurple";
import {AboutCreateImage, CreateText} from "../student-and-teacher/how-it-works/HowItWorkComponents";
import Routes from "../../../utils/Routes";
import {SUPPORT_EMAIL} from "../../../constants/common";

const CreateTitleDesk = ({title, isFirst = false, variant}: { title: string; isFirst?: boolean; variant?: any }) => (
    <Typography fontWeight="bold" color={Colors.ANSWER} fontSize={18}>
        {title}
    </Typography>
);

const CreateTitleMob = ({title, isFirst = false, variant}: { title: string; isFirst?: boolean; variant?: any }) => (
    <Typography fontWeight="bold" color={Colors.ANSWER} variant={variant ? variant : "body1"} pb={1}>
        {title}
    </Typography>
);

const CreateTextDesk = ({children, variant}: any) => (
    <Typography component="span" fontSize={16}>
        {children}
    </Typography>
);
export default function About() {
    const history = useHistory();
    const {isMobile} = useQueryMedia();
    const [expand, setExpand] = useState<boolean>(false);

    const routeToPrivacy = () => history.push(Routes.PRIVACY_POLICY);
    const routeToTerms = () => history.push(Routes.TERMS_AND_CONDITIONS);

    useEffect(() => {
        if (expand) {
            document.body.style.setProperty("background-color", "#2b388d");
        }
    }, [expand]);

    const responsive = {
        xs: 10,
        sm: 9,
        md: 7,
        lg: 6,
        xl: 5.5,

        border: "1px solid " + Colors.LIGHT_BLUE_HEADER,
        borderRadius: "15px",
        padding: 2,
    };
    return (
        <Grid container item xs={12} className="ac-about-page" alignItems="flex-end">
            <Grid container p={0} pt={expand ? 17 : 0} className="ac-about-page__content" justifyContent="center"
                  alignItems="center" flexDirection="column">
                <LogoBigPurple/>
                <Typography variant="h6" fontWeight="bold">
                    Open 4 Feedback
                </Typography>
                <Typography>A platform that incentivizes participation and promotes</Typography>
                <Typography>interactive teaching</Typography>

                <Grid container justifyContent="center" alignItems="center" rowSpacing={2}
                      columnSpacing={{xs: 1, sm: 2, md: 3}} py={2}>
                    <Grid item xs={10} sm={8} md={3}>
                        <ButtonCustom onClick={() => history.push(Routers.REGISTER_STUDENT)} gradient="green"
                                      textColor="black" label="Student" fontWeight="600" startIcon={<StudentIcon/>}/>
                    </Grid>
                    <Grid item xs={10} sm={8} md={3}>
                        <ButtonCustom onClick={() => history.push(Routers.TEACHER_LOGIN)} gradient="blue"
                                      label="Teacher" fontWeight="600"
                                      startIcon={<ProffessorIcon width="50px" height="30px"/>}/>
                    </Grid>
                </Grid>

                <Grid container item justifyContent="center">
                    <Typography variant="body2">
                        <Typography variant="body2" fontWeight="bold">
                            This platform provides:
                        </Typography>
                        Real-time feedback to teachers during the class.
                        <br/>
                        Space for open classroom conversation without social and peer pressures.
                    </Typography>
                </Grid>

                <Grid container justifyContent="center" textAlign="center" pt={1}>
                    <Grid item xs={4.5} sm={4.5} md={4} lg={4} xl={4} alignSelf="center">
                        <div className="ac-about-page__white-line" style={{float: "right"}}/>
                    </Grid>
                    <Grid item xs={3} sm={2} md={1} lg={1} xl={1}>
                        <Typography variant="body1">Learn More</Typography>
                    </Grid>
                    <Grid item xs={4.5} sm={4.5} md={4} lg={4} xl={4} alignSelf="center">
                        <div className="ac-about-page__white-line"/>
                    </Grid>
                </Grid>

                <Grid container item justifyContent="center">
                    <IconButton onClick={() => setExpand(!expand)}>
                        <ArrowIcon rotate={expand ? 180 : 0}/>
                    </IconButton>
                </Grid>

                <Grid container justifyContent="center" pt={2}>
                    <Grid container item xs={12} justifyContent="center">
                        <Grid item mb={3} sx={{display: expand ? "flex" : "none"}} {...responsive}>
                            {isMobile ? (
                                <Stack>
                                    <CreateTitleMob variant="body2" title={ABOUT_TEXTS.REALTIME.title}/>
                                    <Stack direction="row" spacing={2}>
                                        <AboutCreateImage width={16} image={Images.NEW_REMOTE_MOB}/>
                                        <Stack textAlign="left">
                                            <CreateText fontSize={10}>{ABOUT_TEXTS.REALTIME.text}</CreateText>
                                        </Stack>
                                    </Stack>
                                </Stack>
                            ) : (
                                <Stack direction="row" spacing={2}>
                                    <AboutCreateImage image={Images.NEW_REMOTE_WEB}
                                                      responseWidth={{md: "19vh", lg: "22vh", xl: "22vh"}}/>
                                    <Stack>
                                        <Box textAlign="left">
                                            <CreateTitleDesk variant="body2" title={ABOUT_TEXTS.REALTIME.title}/>
                                        </Box>
                                        <Box flex={1} textAlign="left" alignContent="center">
                                            <CreateTextDesk>{ABOUT_TEXTS.REALTIME.text}</CreateTextDesk>
                                        </Box>
                                    </Stack>
                                </Stack>
                            )}
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} justifyContent="center">
                        <Grid item mb={3} sx={{display: expand ? "flex" : "none"}} {...responsive}>
                            {isMobile ? (
                                <Stack>
                                    <CreateTitleMob variant="body2" title={ABOUT_TEXTS.VIEWING.title}/>
                                    <Stack alignItems={"center"} pb={1}>
                                        <AboutCreateImage width={25} image={Images.NEW_VIEW_PDF}/>
                                    </Stack>
                                    <Stack textAlign="left">
                                        <CreateText fontSize={10}>{ABOUT_TEXTS.VIEWING.text}</CreateText>
                                    </Stack>
                                </Stack>
                            ) : (
                                <Stack direction="row" spacing={2}>
                                    <Stack>
                                        <Box textAlign="left">
                                            <CreateTitleDesk variant="body2" title={ABOUT_TEXTS.VIEWING.title}/>
                                        </Box>
                                        <Box flex={1} textAlign="left" alignContent="center">
                                            <CreateTextDesk>{ABOUT_TEXTS.VIEWING.text}</CreateTextDesk>
                                        </Box>
                                    </Stack>
                                    <AboutCreateImage responseWidth={{md: "35vh", lg: "40vh", xl: "43vh"}}
                                                      image={Images.NEW_VIEW_PDF}/>
                                </Stack>
                            )}
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} justifyContent="center">
                        <Grid item mb={3} sx={{display: expand ? "flex" : "none"}} {...responsive}>
                            {isMobile ? (
                                <Stack>
                                    <CreateTitleMob variant="body2" title={ABOUT_TEXTS.ANONYMOUS.title}/>
                                    <Stack direction="row" textAlign="left" spacing={2}>
                                        <CreateText fontSize={10}>{ABOUT_TEXTS.ANONYMOUS.text}</CreateText>
                                        <AboutCreateImage width={16} image={Images.NEW_QA}/>
                                    </Stack>
                                </Stack>
                            ) : (
                                <Stack direction="row" spacing={2}>
                                    <AboutCreateImage image={Images.NEW_QA}
                                                      responseWidth={{md: "19vh", lg: "22vh", xl: "22vh"}}/>
                                    <Stack>
                                        <Box textAlign="left">
                                            <CreateTitleDesk variant="body2" title={ABOUT_TEXTS.ANONYMOUS.title}/>
                                        </Box>
                                        <Box flex={1} textAlign="left" alignContent="center">
                                            <CreateTextDesk>{ABOUT_TEXTS.ANONYMOUS.text}</CreateTextDesk>
                                        </Box>
                                    </Stack>
                                </Stack>
                            )}
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} justifyContent="center">
                        <Grid item mb={3} sx={{display: expand ? "flex" : "none"}} {...responsive}>
                            {isMobile ? (
                                <Stack>
                                    <CreateTitleMob variant="body2" title={ABOUT_TEXTS.ANALYTICS.title}/>
                                    <Stack alignItems={"center"} pb={1}>
                                        <AboutCreateImage width={25} image={Images.NEW_STATS_PREVIEW}/>
                                    </Stack>
                                    <Stack textAlign="left">
                                        <CreateText fontSize={10}>{ABOUT_TEXTS.ANALYTICS.text}</CreateText>
                                    </Stack>
                                </Stack>
                            ) : (
                                <Stack direction="row" spacing={2}>
                                    <Stack>
                                        <Box textAlign="left">
                                            <CreateTitleDesk variant="body2" title={ABOUT_TEXTS.ANALYTICS.title}/>
                                        </Box>
                                        <Box flex={1} textAlign="left" alignContent="center">
                                            <CreateTextDesk>{ABOUT_TEXTS.ANALYTICS.text}</CreateTextDesk>
                                        </Box>
                                    </Stack>
                                    <AboutCreateImage responseWidth={{md: "35vh", lg: "40vh", xl: "43vh"}}
                                                      image={Images.NEW_STATS_PREVIEW}/>
                                </Stack>
                            )}
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} justifyContent="center">
                        <Grid item mb={3} sx={{display: expand ? "flex" : "none"}} {...responsive}>
                            {isMobile ? (
                                <Stack>
                                    <CreateTitleMob variant="body2" title={ABOUT_TEXTS.REGISTRATION.title}/>
                                    <Stack direction="row" spacing={2}>
                                        <AboutCreateImage width={16} image={Images.NEW_REGISTRATION}/>
                                        <Stack textAlign="left">
                                            <CreateText fontSize={10}>{ABOUT_TEXTS.REGISTRATION.text}</CreateText>
                                        </Stack>
                                    </Stack>
                                </Stack>
                            ) : (
                                <Stack direction="row" spacing={2}>
                                    <AboutCreateImage image={Images.NEW_REGISTRATION}
                                                      responseWidth={{md: "19vh", lg: "22vh", xl: "22vh"}}/>
                                    <Stack>
                                        <Box textAlign="left">
                                            <CreateTitleDesk variant="body2" title={ABOUT_TEXTS.REGISTRATION.title}/>
                                        </Box>
                                        <Box flex={1} textAlign="left" alignContent="center">
                                            <CreateTextDesk>{ABOUT_TEXTS.REGISTRATION.text}</CreateTextDesk>
                                        </Box>
                                    </Stack>
                                </Stack>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                {false && <span style={{
                    fontSize: 10,
                    color: "white",
                    position: "absolute",
                    right: "5px",
                    bottom: "5px"
                }}>{`v${packageJson.version}`}</span>}
            </Grid>
            <Grid container item  justifyContent={{xs:"space-around", md:"space-between"}}  p={6} alignItems="center">
                <Typography variant="caption">
                    © 2025 Open4feedback. All rights reserved •{" "}
                    {/*<Link href="/terms-of-service" underline="hover" color="inherit">*/}
                    {/*    Terms of Service*/}
                    {/*</Link>{" "}*/}
                    {/*•{" "}*/}
                    <Link underline="hover" sx={{ cursor: "pointer" }} color="primary.contrastText" onClick={routeToPrivacy}>
                        Privacy Policy
                    </Link>
                </Typography>
                <Typography variant="caption">
                    Contact:{" "}
                    {/*<Link href="/terms-of-service" underline="hover" color="inherit">*/}
                    {/*    Terms of Service*/}
                    {/*</Link>{" "}*/}
                    {/*•{" "}*/}
                    <Link underline="hover" sx={{ cursor: "pointer" }} color="primary.contrastText" href={`mailto:${SUPPORT_EMAIL}`}>
                        {SUPPORT_EMAIL}
                    </Link>
                </Typography>
            </Grid>
        </Grid>
    );
}
export const ABOUT_TEXTS = {
    REALTIME: {
        title: "REAL-TIME FEEDBACK",
        text: "In contrast to other platforms that allow feedback only in response to a question or a quiz, our platform allows students to provide feedback at any time during the lecture. Instead of typing a question, students are encouraged to focus on the presentation and provide feedback through the interface that resembles a remote-control. Since the interface is simple to use and feedback is anonymous, students are incentivized to participate and provide honest response.",
    },
    VIEWING: {
        title: "VIEWING FEEDBACK",
        text: "For the teacher, feedback is non-disruptive. It appears in a bar beneath a slide, showing participating students' responses. This provides the teacher with immediate awareness of the level of student's understanding without pausing the lecture.",
    },
    ANONYMOUS: {
        title: "ANONYMOUS Q & A",
        text: "To encourage participation that is free from peer and social pressures, students post questions and answers (Q&A) under pseudonyms. The unique characteristic of the platform is the algorithm that provides accountable anonymity which means that students are anonymous but accountable for their posts. Teachers can allow anonymous Q&A during and/or after the lecture. Most importantly, Q&A can continue after the lecture is over.",
    },
    ANALYTICS: {
        title: "ANALYTICS",
        text: "The platform collects students' responses during the lecture and integrates them into a histogram – feedback statistics. After the class, the teacher can review the statistics and if needed modify the presentation.",
    },
    REGISTRATION: {
        title: "REGISTRATION",
        text: "For teachers, the registration requires only a valid school email. Students do not need to provide email or any personal information in order to register. Instead, they only have to attend a class and register through the class code that is given to them by the teacher at the beginning of the lecture.",
    },
};
